'use strict';

namespace Recommendations {
    class RecommendedHotelGroups {

        tabItems: any[];
        destinationType: string;
        destinationId: string;
        destinationTitle: string;
        isPopulated: boolean;
        trackRecommendedHotelGroups: ITrackRecommendedHotelGroups;

        constructor(
            private $location: ng.ILocationService,
            private tripService: Core.TripService,
            private dateUtil,
            private recommenderTracker,
            $http: ng.IHttpService
        ) {
            // [ Core.FieldType.Global, Core.FieldType.Titles, Core.FieldType.IndicativePrice,
            //   Core.FieldType.Distances, Core.FieldType.Url ]
            const FieldFlags = 583;

            $http.post('api/hotels/landingpages/recommendedhotelgroups',{
                    DomainId: TRPCONFIG.Domain.DomainId,
                    CultureCode: TRPCONFIG.Domain.CultureCode,
                    DestinationType: this.destinationType,
                    DestinationId: this.destinationId,
                    HotelCountPerGroup: 3,
                    FieldFlags,
                    CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                }, { ignoreErrors: true })
                .then(({data}) => {
                    this.tabItems = data;
                    this.isPopulated = !!_.get(this.tabItems, '[0].Hotels[0]');

                    this.trackRecommendedHotelGroups =
                        recommenderTracker.trackRecommendedHotelGroupsFactory(this.tabItems);
                    if (this.tabItems.length) {
                        this.trackRecommendedHotelGroups.trackView(this.tabItems[0]);
                    }

                    _.forEach(this.tabItems, tab => {
                        _.forEach(tab.Hotels, hotel => {
                            hotel.Title = hotel.ShortTitle || hotel.Title;
                            hotel.__bd4reco = this.trackRecommendedHotelGroups.__bd4reco(tab, hotel);
                        });
                    });
                });
        }

        getDealUrl(hotel) {
            let getDate = weeksFromNow =>
                this.dateUtil.serialiseDate(this.dateUtil.getNextSaturday(weeksFromNow)).split('T')[0];
            let deal:any = _.get(hotel, 'Deals[0]');
            if (deal) {
                return '';
            } else {
                return hotel.Url + '?' + $.param({
                    startDate: deal ? deal.CheckInDate : getDate(2),
                    endDate: deal ? deal.CheckOutDate : getDate(3),
                    autoSearch: '1',
                    __bd4reco: hotel.__bd4reco,
                });
            }
        }

        goToDeal(tabItem, hotel) {
            let deal:any = _.get(hotel, 'Deals[0]');
            if (deal) {
                this.tripService
                    .getTripIdForDeal(deal, 'recommendedHotelGroups')
                    .then(tripId => {
                        this.$location.path(`/hotels/${tripId}/${hotel.Id}`)
                            .search('__bd4reco', hotel.__bd4reco);
                    });
            }
            this.trackRecommendedHotelGroups.trackClick(tabItem, hotel);
        }

        tabClick(tabItem) {
            this.trackRecommendedHotelGroups.trackView(tabItem);
        }
    }

    angular
        .module('recommendations')
        .directive('recommendedHotelGroups', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                bindToController: {
                    destinationType: '@',
                    destinationId: '@',
                    destinationTitle: '@',
                    isPopulated: '=',
                },
                controller: RecommendedHotelGroups,
                controllerAs: 'rhg',
                templateUrl: 'partials/recommendations/recommendedHotelGroups',
            };
        });
}
